import { render, staticRenderFns } from "./LandingCarrousel.vue?vue&type=template&id=333b2207&scoped=true&"
import script from "./LandingCarrousel.vue?vue&type=script&lang=js&"
export * from "./LandingCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./LandingCarrousel.vue?vue&type=style&index=0&id=333b2207&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b2207",
  null
  
)

component.options.__file = "LandingCarrousel.vue"
export default component.exports